export interface SecurityDomainValidation {
  valid: boolean;
  message: string | null;
  domain: string;
}

export function getSecurityDomainDefaults(): string[] {
  return ['parcelengineering.com'];
}

export function formatApprovedDomainCount(count: number): string {
  return `${count} approved email ${count === 1 ? 'domain' : 'domains'}`;
}

function normalizeSecurityDomainInput(value: string): string {
  const withoutProtocol = value
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, '');
  if (withoutProtocol.includes('@')) return '';
  return (
    withoutProtocol
      .split('/')[0]
      ?.replace(/^www\./, '')
      .replace(/\.$/, '') ?? ''
  );
}

export function getSecurityDomainValidation(
  value: string,
  existingDomains: string[],
): SecurityDomainValidation {
  const domain = normalizeSecurityDomainInput(value);

  if (
    !/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+$/.test(
      domain,
    )
  ) {
    return { valid: false, message: 'Enter a valid company domain.', domain };
  }

  if (existingDomains.includes(domain)) {
    return { valid: false, message: 'That domain is already approved.', domain };
  }

  return { valid: true, message: null, domain };
}
